import { render } from "./PlayerView.vue?vue&type=template&id=6b1723c7&ts=true"
import script from "./PlayerView.vue?vue&type=script&lang=ts"
export * from "./PlayerView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Players/PlayerView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b1723c7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b1723c7', __exports__)) {
    api.reload('6b1723c7', __exports__)
  }
  
  module.hot.accept("./PlayerView.vue?vue&type=template&id=6b1723c7&ts=true", () => {
    api.rerender('6b1723c7', render)
  })

}


export default __exports__